import { render } from "./ScreenShareTile.vue?vue&type=template&id=6a16bb07&scoped=true"
import script from "./ScreenShareTile.vue?vue&type=script&lang=js"
export * from "./ScreenShareTile.vue?vue&type=script&lang=js"

import "./ScreenShareTile.vue?vue&type=style&index=0&id=6a16bb07&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a16bb07"]])

export default __exports__